<template>
	<div class="container">
		
		<div class="left">
			<div class="row row-boxes">
				<div class="col half">
					<box-map />
				</div>
				<div class="col half">
					<box-projects />
				</div>
			</div>
		</div>
		
		<div class="right">
			<search />
		</div>

	</div>
</template>

<script>
import BoxMap from "@/components/projects/box-map";
import BoxProjects from "@/components/projects/box-projects";
import Search from "@/components/projects/search";

export default {
	name: "view-home",
	components: { BoxMap, BoxProjects, Search },
	mounted () {
		this.$store.dispatch("cancel");
	}
};
</script>

<style lang="stylus" scoped>
@import '../assets/css/app'
@import '../assets/css/grid'

.row-boxes
	height 100%
	> .col
		height 100%
	
</style>